import React, { useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";

function SchoolFilter({ appliedFilters, show, onHide, onApplyFilter, onClear }) {
  const [filters, setFilters] = useState({
    registration_number: appliedFilters?.registration_number || "",
    school_code: appliedFilters?.school_code || "",
    school_name: appliedFilters?.school_name || "",
    status: appliedFilters?.status || "",
    school_type: appliedFilters?.school_type || "",
  });

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleClearAll = () => {
    setFilters({
      registration_number: "",
      school_code: "",
      school_name: "",
      status: "",
      school_type: "",
    });
    if (onClear) {
      onClear();
    }
  };

  const handleApply = () => {
    // Remove empty values before applying
    const cleanedFilters = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim && filters[key].trim() !== "") {
        cleanedFilters[key] = filters[key].trim();
      } else if (filters[key] && filters[key] !== "") {
        cleanedFilters[key] = filters[key];
      }
    });
    
    if (onApplyFilter) {
      onApplyFilter(cleanedFilters);
    }
  };

  const isFilterApplied = () => {
    return filters.registration_number || filters.school_code || 
           filters.school_name || filters.status 
  };

  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
      backdrop="static"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter Schools
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        <Form className="filter_form">
          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              Registration Number
            </label>
            <Form.Control
              type="text"
              placeholder="Enter registration number"
              name="registration_number"
              value={filters.registration_number}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              School Code
            </label>
            <Form.Control
              type="text"
              name="school_code"
              placeholder="Enter school code"
              value={filters.school_code}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              School Name
            </label>
            <Form.Control
              type="text"
              name="school_name"
              placeholder="Enter school name"
              value={filters.school_name}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">School Type</label>
            <Form.Select
              name="school_type"
              value={filters.school_type}
              onChange={handleFilterChange}
            >
              <option value="">All Types</option>
              <option value="Private">Private</option>
              <option value="Public">Public</option>
              <option value="Government">Government</option>
              <option value="International">International</option>
            </Form.Select>
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </div>
        </Form>
        
        <div className="offcanvas-footer mt-4 d-flex gap-2">
          <button 
            className="btn blue_border flex-grow-1" 
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            className="btn red_button flex-grow-1"
            onClick={handleApply}
          >
            Apply Filters
          </button>
        </div>
     
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SchoolFilter;